import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

import NodeWidget from '../nodeWidget/NodeWidget';
import { NodeModelTypeEnum } from '../enums';
import { AirFilterNodeModel } from './AirFilterNodeModel';
import { AirFilterNodeWidget } from './AirFilterNodeWidget';

export class AirFilterNodeFactory extends AbstractReactFactory {
  constructor(private isMainMap) {
    super(NodeModelTypeEnum.AirFilter);
    this.isMainMap = isMainMap;
  }

  generateModel() {
    return new AirFilterNodeModel();
  }

  nodeUI(event) {
    return <AirFilterNodeWidget engine={this.engine} node={event.model} width={22} height={58} />;
  }

  generateReactWidget(event) {
    return this.isMainMap ? (
      <NodeWidget entity={event.model.getEntity()} onDevices={event.model.getOnDevices()} isDummy>
        {this.nodeUI(event)}
      </NodeWidget>
    ) : (
      this.nodeUI(event)
    );
  }
}
